import type { ReactNode } from 'react';
import './DirectChatDaySection.css';

export type DirectChatDaySectionProps = {
  dayKey: string;
  children: ReactNode;
};

export function DirectChatDaySection({ dayKey, children }: DirectChatDaySectionProps) {
  return (
    <div className="directChatDaySection" data-dm-day-section={dayKey}>
      {children}
    </div>
  );
}
